module.exports = __webpack_public_path__ + "img/block1ipad.d942345a.jpg";